module.exports = __webpack_public_path__ + "img/fbt-iocn08.dced86bc.svg";